import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class YoutubeDataExtractorService {
  constructor(
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService
  ) {}

  extractYoutubeId(url: string): string {
    try {
      const extractYoutubeLinkRegex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|live\/|embed\/|shorts\/|channel\/|c\/|user\/|@[\w-]+|playlist\?list=)|youtu\.be\/)([\w-]+)/gi;

      const youtubeLink = url.match(extractYoutubeLinkRegex)[0];

      const regex =
        /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|live\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;

      const videoId = youtubeLink.match(regex)?.[1];

      if (!videoId) {
        this.toastrService.error('URL inválida');
      }
      return videoId;
    } catch {
      this.toastrService.warning(`URL fornecida: ${url}`);
      this.toastrService.error(
        'Erro ao extrair ID do vídeo, verifique a URL fornecida.'
      );
      throw new Error();
    }
  }

  prepareEmbededUrl(
    videoId: string,
    settings?: {
      autoplay?: number;
      mute?: number;
      controls?: number;
    }
  ): SafeResourceUrl {
    const { autoplay = 0, mute = 0, controls = 1 } = settings || {};
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=${autoplay}&mute=${mute}&controls=${controls}`
    );
  }
}
